import React, {Component} from "react";

import Home from '../components/Home';

class HomePage extends Component {
  render() {
    return (
      <div>
              <h2>
          Country profiles
        </h2>
        <p>
          Every two years, states submit national reports on their implementation of
          the UN Programme of Action and its International Tracing Instrument. Country
          profiles highlight key information included in States’ most recent national reports. <i>(Data
          is reflected in country profiles if national reports are submitted online or consistent
           with the latest reporting template.)</i>
        </p>
        <p>
          Information featured in this website currently reflects only 2024 national reports, to be updated before BMS8.
          </p>

        <Home />
      </div>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/pages/Home.js